<template>
  <div :style="{ width: computedWidth }">

  <span
        class="SkeletonBox mb-3"
        :style="{ height: '25px', width: '40%' }"
      ></span>


    <div v-for="index in line" :key="index"    :style="{ height: '20px'}">
      <span
        class="SkeletonBox"
        :style="{ height: '10px', width: rondomWidth() }"
      ></span>
    </div>
<div class="text-center">
       <div
        class="SkeletonBox my-5"
        :style="{ height: '250px', width: '250px' }"
      ></div>

</div>

   <div v-for="index in line" :key="index"    :style="{ height: '20px'}">
      <span
        class="SkeletonBox"
        :style="{ height: '10px', width: rondomWidth() }"
      ></span>
    </div>


  </div>
</template>

<script>
export default {
  name: "Skeleton",
  props: {
    maxWidth: {
      // The default maxiumum width is 100%.
      default: 90,
      type: Number
    },
    minWidth: {
      // Lines have a minimum width of 80%.
      default: 30,
      type: Number
    },
    height: {
      // Make lines the same height as text.
      default: "1em",
      type: String
    },

    line: {
      // Make lines the same height as text.
      default: 5,
      type: Number
    },
    width: {
      // Make it possible to define a fixed
      // width instead of using a random one.
      default: null,
      type: String
    }
  },
  computed: {

    computedWidth() {
      // Either use the given fixed width or
      // a random width between the given min
      // and max values.
      return (
        this.width ||
        `${Math.floor(
          Math.random() * (this.maxWidth - this.minWidth) + this.minWidth
        )}%`
      );
    }
  },
  methods:{
    rondomWidth() {

      return `${Math.floor(
          Math.random() * (this.maxWidth - this.minWidth) + this.minWidth
        )}%`;
    }
  }
};
</script>

<style lang="scss">
.SkeletonBox {
  display: inline-block;
  position: relative;
  vertical-align: middle;
  overflow: hidden;
  background-color: #dddbdd;
  &::after {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    transform: translateX(100%);
    background-image: linear-gradient(
      90deg,
      rgba(#fff, 0) 0,
      rgba(#fff, 0.2) 20%,
      rgba(#fff, 0.5) 60%,
      rgba(#fff, 0)
    );
    animation: shimmer 1s infinite;
    content: "";
  }
  @keyframes shimmer {
    100% {
      transform: translateX(-100%);
    }
  }
}
</style>
